import { startCheckout } from "@/lib/payments";
import { getVisitorId, getReferralCode, trackEvent } from "@/lib/tracking";

export function buyBundle(lookupKey, extra = {}) {
  const meta = { ...extra };
  const vid = getVisitorId();
  if (vid) meta.visitor_id = vid;
  const ref = getReferralCode();
  if (ref) meta.referral_code = ref;
  trackEvent("checkout_start");
  sessionStorage.setItem("noxway_checkout_started", "1");
  startCheckout(lookupKey, meta);
}
